import { useState, useEffect } from "react";
import { initialStateGlobalSettings } from './state'

function getStorageValue(key, defaultValue) {
    // getting stored value
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem(key);
      const initial = saved !== null ? JSON.parse(saved) : defaultValue;
      return initial;
    }
  }

export const resetStateGlobalSettings = (state) =>  {
  const initial = initialStateGlobalSettings()
  Object.keys(initial).forEach(key => { state[key] = initial[key] })
};

export const saveToLocalStorage = (key, data) => {
  try{
    localStorage.setItem(key, JSON.stringify(data));
  }catch(error){
    console.log("error: " + error);
  }
  
};

export const loadFromLocalStorage = (key) => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
};

export const clearLocalCookies = () => {
  // To clear the whole data stored in localStorage
  localStorage.clear();
  localStorage.removeItem("mieUid");
  localStorage.removeItem("mieEmail");
};

export const useLocalStorage = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    return getStorageValue(key, defaultValue);
  });

  useEffect(() => {
    // storing input name
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
};